import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"


export default function useStores(props, emit, storeData) {

    // Get toast interface
    const toast = useToast()

    const storeStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getStores = (url = null) => {
        store.dispatch("getStores", {
            url,
            search: search.value,
            status: storeStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true

        if (storeData.value.id) {
            store.dispatch('updateStore', storeData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("فروشگاه با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getStores")
                        closeModal()
                    }
                })
        } else {
            store
                .dispatch("createStore", storeData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success("فروشگاه با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getStores")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }

    const storeSettlement = () => {
        loading.value = true

        if (storeData.value.id) {
            store.dispatch('storeSettlement', storeData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("تسویه فروشگاه موردنظر با موفقیت انجام شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getStores")
                        closeModal()
                    }
                }).catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }


    return {
        show,
        storeStatus,
        search,
        perPage,
        loading,
        errors,
        getStores,
        onSubmit,
        storeSettlement,
        closeModal,
    }
}